<template>
    <div class="block block-rounded">
        <div class="block-header block-header-default">
            <h3 class="block-title">Activity</h3>
        </div>

        <div class="block-content">
            <div class="d-flex justify-content-between mb-4">
                <h4 class="m-0">
                    Current Status:
                    {{ status }}
                    <i v-if="isLookingForLogs" class="fa fa-cog fa-spin"></i>
                </h4>

                <div class="btn-group">
                    <button class="btn btn-sm btn-primary" v-if="canRetry" v-on:click="retry()">
                        Retry
                    </button>

                    <button class="btn btn-sm" v-if="! isLookingForLogs && ! gotMoreLogs" v-on:click="fetchLogs();gotMoreLogs = true">
                        Get More Logs
                    </button>
                </div>
            </div>

            <div v-if="logs.length === 0" class="alert alert-info" role="alert">
                No logs yet.
            </div>

            <div v-else class="table-responsive">
                <table class="table table-sm table-bordered table-vcenter">
                    <thead>
                        <tr>
                            <th style="width: 180px;">Time</th>
                            <th>Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="log in logs" :key="log.id">
                            <td>{{ log.created_at }}</td>
                            <td>{{ log.message }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import { useFetch } from "@/components/useFetch";

const props = defineProps({
    logsUrl: String,
    retryUrl: String,
    initialCanRetry: Boolean,
    initialLogs: Array,
    initialStatus: String,
});

const status = ref(''); // initial empty value
const logs = ref(props.initialLogs ?? []);
const gotMoreLogs = ref(false);

const canRetry = ref(props.initialCanRetry ?? false);
const isLookingForLogs = ref(false);

const fetchLogs = async () => {
    const response = await useFetch(
        props.logsUrl,
        {
            method: "GET",
        },
    );

    if (response.ok) {
        const { data } = await response.json();

        canRetry.value = data.canRetry;
        logs.value = data.logs;
        status.value = data.status;

        gotMoreLogs.value = true;
    }
};

const retry = async () => {
    if (! confirm('Are you sure you wish to reapply this order?')) {
        return;
    }

    const response = await useFetch(
        props.retryUrl,
        {
            method: "POST",
            body: {
                //
            }
        },
    );

    if (response.ok) {
        fetchLogs();
    }
};

let pollInterval = null;

const startPolling = () => {
    if (pollInterval !== null) {
        return;
    }

    pollInterval = window.setInterval(() => {
        fetchLogs();
    }, 10000);
};

// I don't know if I care about stopping the poll
// stopPolling() {
//     if (this.pollInterval === null) {
//         return;
//     }

//     window.clearInterval(this.pollInterval);
//     this.pollInterval = null;
// };

// I don't think this is needed by copilot made it
// ensurePollingState() {
//     if (this.orderStatus === 'processing') {
//         this.startPolling();
//         return;
//     }

//     this.stopPolling();
// };

// this is impossible?
// onMounted(() => {
//     if (isLookingForLogs.value) {
//         startPolling();
//     }
// });

watch(
    status,
    () => {
        isLookingForLogs.value = status.value == 'pending' || status.value == 'processing';
    },
);

watch(
    isLookingForLogs,
    () => {
        if (isLookingForLogs.value) {
            startPolling();
        }
    },
);

// now trigger the watchers
status.value = props.initialStatus ?? 'pending';
</script>
